import _createClass from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/db/Projects/agora/agora-web/node_modules/.pnpm/@babel+runtime@7.3.1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import 'whatwg-fetch';
import merge from 'lodash.merge';
import parse from 'parse-link-header';
import { refreshAuthIfNeeded } from './authUtils';
export var ResponseError = /*#__PURE__*/function (_Error) {
  function ResponseError(statusText, response) {
    var _this;
    _classCallCheck(this, ResponseError);
    _this = _callSuper(this, ResponseError);
    _defineProperty(_this, "statusText", void 0);
    _defineProperty(_this, "response", void 0);
    _this.statusText = statusText;
    _this.response = response;
    return _this;
  }
  _inherits(ResponseError, _Error);
  return _createClass(ResponseError);
}(/*#__PURE__*/_wrapNativeSuper(Error));

/**
 * @param response Response
 * @returns Promise<Response>
 */
export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response);
  }
  var error = new ResponseError(response.statusText, response);
  return Promise.reject(error);
}
function parseLinkHeaders(response) {
  return parse(response.headers.get('Link'));
}
export function isJson(response) {
  var contentType = response.headers.get('content-type');
  return response.status !== 204 && contentType && contentType.indexOf('application/json') !== -1;
}
export default function authFetch(url, opts) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$returnLinkHeader = _ref.returnLinkHeaders,
    returnLinkHeaders = _ref$returnLinkHeader === void 0 ? false : _ref$returnLinkHeader,
    _ref$returnRaw = _ref.returnRaw,
    returnRaw = _ref$returnRaw === void 0 ? false : _ref$returnRaw;
  return refreshAuthIfNeeded().then(function () {
    var token = localStorage.getItem('token');
    var authOpts = {
      headers: {
        Authorization: "Bearer ".concat(token),
        'Cache-Control': 'no-cache'
      },
      credentials: 'include'
    };
    return fetch(url, merge(authOpts, opts));
  }).then(checkHttpStatus).then(function (response) {
    var payload = !returnRaw && isJson(response) ? response.json() : response.body;
    if (returnLinkHeaders) {
      return payload.then(function (p) {
        return {
          linkHeaders: parseLinkHeaders(response),
          response: p
        };
      });
    }
    return payload;
  });
}